// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 60px 40px;
  border-radius: 9px;
  text-align: center;
  text-transform: uppercase;
}
.wrapper .cross-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 25px;
  height: 25px;
  max-height: 25px;
  max-width: 25px;
  min-height: 25px;
  min-width: 25px;
  padding: 0px;
  z-index: 99;
}
.wrapper .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .cross-icon:hover {
  background: #f2dbd9;
}
.wrapper .title {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.wrapper .subtitle {
  font-family: AppFont;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  margin-bottom: 20px;
}
.wrapper .input-email {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper .input-email ion-label {
  font-family: AppFont;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
}
.wrapper .input-email ion-item {
  width: 100%;
  text-align: center;
  height: 40px;
  border-bottom: 1px dashed var(--ion-color-primary);
  --background: transparent;
  margin-bottom: 10px;
  margin-top: 0px;
  --padding-start: 0px;
}
.wrapper .input-email ion-item ion-input {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 90%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.wrapper .button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .button-wrapper ion-button {
  margin: 5px;
}
.wrapper .button-wrapper .sign-up, .wrapper .button-wrapper .login {
  --background: #2D69AA;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  min-height: 54px;
  --border-width: 0px;
}
.wrapper .button-wrapper .guest {
  --background: transparent;
  color: var(--color-black);
  --border-width: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ask-to-create-account-modal/ask-to-create-account-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAAD;AAEC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAAF;AACE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AACH;AACE;EACC,mBAAA;AACH;AAEC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AADF;AAGC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,mBAAA;AAFF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF;AAGE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AADH;AAGE;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kDAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AADH;AAEG;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAAJ;AAIC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF;AAGE;EACC,WAAA;AADH;AAIE;EACC,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFH;AAIE;EACC,yBAAA;EACA,yBAAA;EACA,mBAAA;AAFH","sourcesContent":[".wrapper {\n\tpadding: 60px 40px;\n\n\tborder-radius: 9px;\n\ttext-align: center;\n\ttext-transform: uppercase;  \n    // background: var(--default-background);\n\t.cross-icon {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 10px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tmax-height: 25px;\n\t\tmax-width: 25px;\n\t\tmin-height: 25px;\n\t\tmin-width: 25px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n\t.title {\n\t\tfont-family: Title;\n\t\tfont-size: 40px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t\tmargin-bottom: 12px;\n\t}\n\t.subtitle {\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0px;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\n\t\tmargin-bottom: 20px;\n\t}\n\t.input-email {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tion-label {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 11px;\n\t\t\tline-height: 85%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t}\n\t\tion-item {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t\theight: 40px;\n\t\t\tborder-bottom: 1px dashed var(--ion-color-primary);\n\t\t\t--background: transparent;\n\t\t\tmargin-bottom: 10px;\n\t\t\tmargin-top: 0px;\n\t\t\t--padding-start: 0px;\n\t\t\tion-input {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 90%;\n\t\t\t\tletter-spacing: 0%;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t}\n\t.button-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tion-button {\n\t\t\tmargin: 5px;\n\t\t}\n\t\t\n\t\t.sign-up, .login {\n\t\t\t--background: #2D69AA;\n\t\t\tcolor: #fff;\n\t\t\tfont-size: 17px;\n\t\t\tfont-weight: 700;\n\t\t\tmin-height: 54px;\n\t\t\t--border-width: 0px;\n\t\t}\n\t\t.guest {\n\t\t\t--background: transparent;\n\t\t\tcolor: var(--color-black);\n\t\t\t--border-width: 0px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
